export enum RoleAssignmentsTableHeadings {
  UserId = 'User ID',
  RoleName = 'Role Name',
  TenantId = 'Tenant ID',
  Status = 'Status',
  ServicePrefix = 'Service Prefix'
}
